import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e1b2ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cerrar Sesión")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Mi Perfil")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-columns" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Dashboard")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "mycontainer" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Cruz Jiminián ")
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", {
        class: _normalizeClass(_ctx.navMenuClas)
      }, [
        _createElementVNode("a", {
          style: {"color":"white"},
          class: "navbar-option",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.hamburger('Cerrar Sesión'))),
          href: "#"
        }, _hoisted_4),
        _createElementVNode("a", {
          style: {"color":"white"},
          class: "navbar-option",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.hamburger('Mi Perfil'))),
          href: "#"
        }, _hoisted_7),
        _createElementVNode("a", {
          style: {"color":"white"},
          class: "navbar-option",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push('/dashboard'))),
          href: "#"
        }, _hoisted_10)
      ], 2),
      _createElementVNode("nav", null, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("a", {
            class: "item navbar-brand",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (this.$router.push(`/dashboard`))),
            href: "#"
          }, [
            _createElementVNode("img", {
              class: "localIMG",
              src: 
                'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
              
            }, null, 8, _hoisted_12),
            _hoisted_13
          ]),
          _createElementVNode("a", {
            class: "item navbar-brand userName",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hamburger())),
            href: "#"
          }, [
            _createElementVNode("img", {
              class: "rounded-circle",
              src: 
                `https://cruzjiminian-assets-bucket.s3.amazonaws.com/usuario-${this.$store.state.user.username}.jpg`
              
            }, null, 8, _hoisted_14),
            _createTextVNode(" " + _toDisplayString(this.$store.state.user.usuario) + " ", 1),
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.desplegar)
            }, null, 2)
          ])
        ])
      ])
    ])
  ]))
}